import { Button } from 'antd';
import React from 'react';
import { ButtonProps } from 'antd/es/button';

interface Props extends ButtonProps {
  rules?: boolean[];
}

const ReferencedNotesButton = ({ rules, ...props }: Props) => {
  if (rules?.some((cur) => cur)) {
    return null;
  } else {
    return (
      <Button block {...props}>
        Notas Referenciadas
      </Button>
    );
  }
};

export default ReferencedNotesButton;
